import { Card, CardContent } from "@/components/ui/card";
import { Calendar as CalendarIcon, CheckCircle2, ArrowRight, CalendarDays } from "lucide-react";
import { Button } from "@/components/ui/button";

import { Calendar } from "@/components/ui/calendar";
const AppointmentScheduler = () => {
  // De vernieuwde, werkende Google Calendar link
  const calendarLink = "https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ0opvsfVk5XZJdpqsB6pt5KgJCotKhayutCjD4CkZBEyE_P5cBSiijmD1NINfUaS8-DrQmYEzz6?gv=true";

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column: Text & Benefits */}
          <div className="space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-100 text-orange-700 rounded-full font-medium text-sm">
              <CalendarIcon className="h-4 w-4" />
              <span>Plan direct uw afspraak</span>
            </div>
            <h2 className="text-4xl font-bold text-gray-900 leading-tight">
              Gratis adviesgesprek op locatie?
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Kies een datum die u schikt direct in onze agenda. Wij komen graag vrijblijvend langs om uw situatie te bekijken en u te adviseren over de beste oplossing voor uw woning of bedrijf.
            </p>
            <ul className="space-y-4 pt-4">
              {[
                "Direct inzicht in de mogelijkheden",
                "Persoonlijk advies van een specialist",
                "Vrijblijvende offerte op maat"
              ].map((item, i) => (
                <li key={i} className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-500" />
                  <span className="text-gray-700">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Right Column: Calendar CTA */}
          <div className="flex justify-center lg:justify-end">
            <Card className="border-2 border-orange-100 shadow-2xl w-full max-w-md relative overflow-hidden">
              <div className="absolute top-0 left-0 w-full h-2 bg-orange-600" />
              <CardContent className="p-8 text-center flex flex-col items-center">
                <div className="w-20 h-20 bg-orange-50 rounded-full flex items-center justify-center mb-6">
                  <CalendarDays className="h-10 w-10 text-orange-600" />
                </div>
                
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Kies uw moment
                </h3>
                
                <p className="text-gray-600 mb-8">
                  U wordt doorgestuurd naar onze beveiligde Google Calendar omgeving om een beschikbare tijd te selecteren.
                </p>

                <Button 
                  asChild 
                  size="lg"
                  className="w-full h-14 text-lg bg-orange-600 hover:bg-orange-700 text-white font-bold shadow-lg shadow-orange-600/30 group"
                >
                  <a href={calendarLink} target="_blank" rel="noopener noreferrer">
                    Open de Agenda
                    <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
                  </a>
                </Button>
                
                <p className="text-xs text-gray-400 mt-4">
                  Aangedreven door Google Calendar
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AppointmentScheduler;
